/**
 * @file Enumerator of what to do with the deployments when copying a task or task template
 * @author Maarten Lensink
 */
/**
 * How to copy the deployments when copying a task or task template
 */
export var DeploymentCopyOptions;
(function (DeploymentCopyOptions) {
    /**
     * The deployments are not included in the copy
     */
    DeploymentCopyOptions[DeploymentCopyOptions["None"] = 0] = "None";
    /**
     * The deployments are included without resources
     */
    DeploymentCopyOptions[DeploymentCopyOptions["WithResources"] = 1] = "WithResources";
    /**
     * The deployments are included, as well as their resources
     */
    DeploymentCopyOptions[DeploymentCopyOptions["WithoutResources"] = 2] = "WithoutResources";
})(DeploymentCopyOptions || (DeploymentCopyOptions = {}));
